import { AlienIcon, Label, TTranslator } from '@smartshell/ui-kit';
import dayjs from 'dayjs';
import { Column } from 'react-table';

import { TLocalesKeys } from 'localization';

import { ETransfersType, TTransfersData } from '../interfaces';
import s from '../Transfers.module.scss';

export const getTransfersColumns = (
  t: TTranslator<TLocalesKeys>,
  currency: string
): Array<Column<TTransfersData>> => [
  {
    Header: t('payment.date'),
    accessor: ({ transfer: { created_at } }) =>
      dayjs(created_at).format('D MMM YYYY, HH:mm'),
  },
  {
    Header: t('client'),
    accessor: 'user',
    Cell: ({ value }) => {
      return (
        <div className={s.client}>
          <div className={s.client__avatar}>
            {value.avatar_url ? (
              <img
                className={s.header_image}
                src={value.avatar_url}
                alt="avatar"
              />
            ) : (
              <AlienIcon color="disable" />
            )}
          </div>
          <div className={s.client__info}>
            <div className={s.client__name}>
              {value.first_name
                ? `${value.last_name} ${value.first_name[0]}.${
                    value.middle_name && ` ${value.middle_name[0]}.`
                  }`
                : value.phone}
            </div>
            <div className={s.client__phone}>+{value.phone}</div>
          </div>
        </div>
      );
    },
    width: 210,
  },
  {
    Header: t('warehouse.operation'),
    accessor: ({ transfer: { type } }) => type,
    Cell: ({ value }: { value: ETransfersType }) => {
      if (value === ETransfersType.WITHDRAW)
        return (
          <Label
            text={t('withdraw')}
            color="gray-secondary"
            iconName="WalletArrowRightIcon"
            size="s"
          />
        );

      if (value === ETransfersType.DEPOSIT)
        return (
          <Label
            text={t('renewal')}
            color="green"
            size="s"
            iconName="WalletArrowLeftIcon"
          />
        );
    },
  },
  {
    Header: t('sum'),
    accessor: ({ transfer: { sum } }) => `${sum} ${currency}`,
  },
];
